/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';
import type Mithril from 'mithril';

export interface TourStepBodyAttrs extends ComponentAttrs {
	stepId: string;
}

export default class TourStepBody extends Component<TourStepBodyAttrs> {
	protected showFull!: Stream<boolean>;
	protected textShort!: Mithril.Children;
	protected textFull!: Mithril.Children;

	oninit(vnode: Mithril.Vnode<TourStepBodyAttrs, this>) {
		super.oninit(vnode);
		const communityName = app.forum.attribute<string>(`brandDomain`);
		const brandName = app.forum.attribute<string>(`brandName`);

		this.showFull = Stream(false);

		const { stepId } = vnode.attrs;

		this.textShort = app.translator.trans(`glowingblue-orell-thalia-common.forum.tour.home.steps.${stepId}.text.short`, { communityName });
		this.textFull = app.translator.trans(`glowingblue-orell-thalia-common.forum.tour.home.steps.${stepId}.text.full`, { communityName, brandName });

		if (extractText(this.textShort) === extractText(this.textFull)) {
			this.showFull(true);
		}
	}

	view(): Mithril.Children {
		return (
			<div className="TourStepBodyBody">
				{this.showFull() ? (
					<p className="TourStepBody-text TourStepBody--fullText">{this.textFull}</p>
				) : (
					<p className="TourStepBody-text TourStepBody--shortText">{this.textShort}</p>
				)}
				{!this.showFull() && (
					<Button
						className="Button TourStepBody--moreButton Button--flat"
						icon="fas fa-chevron-down"
						onclick={(evt: Event) => {
							evt.preventDefault();
							evt.stopPropagation();
							this.showFull(true);
						}}
					>
						{app.translator.trans('glowingblue-orell-thalia-common.forum.tour.home.more_label')}
					</Button>
				)}
			</div>
		);
	}
}
